import React, { useState } from "react";

import {
  Button,
  Menu,
  MenuItem,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import * as chains from "../constants/chains";

import useIcon from "../hooks/useIcon";

const useStyles = makeStyles((theme) => ({
  iconButton: {
    background: theme.palette.background.paper,
    height: "39px",
    borderRadius: "14px",
    padding: "0px 15px",
    textTransform: "initial",
    color: theme.palette.text.primary,
  },
  coinImage: {
    width: "20px",
    marginRight: theme.spacing(0.5),
  },
  title: {
    lineHeight: 1,
    fontSize: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    color: theme.palette.grey[500],
  },
  meunItem: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    marginTop: theme.spacing(1),
    borderRadius: theme.spacing(1.5),
    "&.active": {
      backgroundColor: theme.palette.background.default,
    },
  },
  coinName: {
    fontWeight: 500,
  },
}));

const StyledMenu = withStyles({
  paper: {
    borderRadius: "20px",
    marginTop: "10px",
    padding: "16px",
    width: "272px",
  },
  list: {
    padding: 0,
  },
})((props) => (
  <Menu
    elevation={2}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
));

function NetworkDropdown({ selectedNetwork }) {
  const classes = useStyles();
  const [iconImage] = useIcon();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  /**
   * Switch To Poligon Network
   */
  const switchNetwork = async (chain) => {
    try {
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: chain.chainId }],
      });
    } catch (switchError) {
      // This error code indicates that the chain has not been added to MetaMask.
      if (switchError.code === 4902) {
        try {
          await window.ethereum.request({
            method: "wallet_addEthereumChain",
            params: [chain],
          });
        } catch (addError) {
          console.log("add error", addError);
        }
      }
      // handle other "switch" errors
      console.log("switch error", switchError);
    }
  };
  return (
    <div>
      {selectedNetwork.symbol && (
        <Button
          aria-label="delete"
          className={classes.iconButton}
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <img
            src={iconImage(selectedNetwork.symbol || "")}
            alt={selectedNetwork.symbol || ""}
            className={classes.coinImage}
          />
          <span className="chainName">{selectedNetwork.chainName || ""}</span>
          <ExpandMoreIcon />
        </Button>
      )}
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <Typography variant="body1" className={classes.title}>
          Select a network
        </Typography>
        {Object.values(chains.chainConfigs).map((value, index) => (
          <MenuItem
            key={index}
            onClick={() => {
              switchNetwork(value);
              handleClose();
            }}
            classes={{ root: classes.meunItem }}
            className={
              value.chainName == selectedNetwork.chainName ? "active" : ""
            }
          >
            <img
              src={iconImage(value.nativeCurrency.name)}
              alt={value.nativeCurrency.name}
              className={classes.coinImage}
            />

            <Typography variant="body1" className={classes.coinName}>
              {value.chainName}
            </Typography>
          </MenuItem>
        ))}
      </StyledMenu>
    </div>
  );
}

export default NetworkDropdown;
